import { createRoot } from "react-dom/client";
import { useEffect, useState } from "@wordpress/element";
import Filters from "./Filters";
import VolunteersList from "./VolunteersList";

import "./editor.scss";
import Pagination from "../components/Pagination.component";
import Constants from "../constants";
import LoadingIcon from "../components/LoadingIcon.component";
import BSHelper from "../BSHelper";

export default function View() {
	const [volunteers, setVolunteers] = useState([]);
	const [jobTypes, setJobTypes] = useState("");
	const [pageIndex, setPageIndex] = useState(1);
	const [pageSize] = useState(10);
	const [totalPages, setTotalPages] = useState(0);
	const [totalItems, setTotalItems] = useState(0);
	const [totalItemsInCurrentPage, setTotalItemsInCurrentPage] = useState(0);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const rootElement = document.getElementById("volunteersListRoot");
	const entityCode = rootElement.getAttribute("data-entityCode");
	const volunteersListApiUrl = `${BSHelper.getApiRootUrl()}${Constants.APIS.VOLUNTEERS.LIST}/${entityCode}`;
	const jobTypesApiUrl = `${BSHelper.getApiRootUrl()}${Constants.APIS.JOBS.TYPES}`;


	const [filtersData, setFiltersData] = useState({
		Keyword: "",
		SortBy: "",
		DatePosted: "",
		SortOrder: "",
		VolunteerDuration: "",
	});

	useEffect(() => {
		fetchJobTypes();
	}, []);

	useEffect(() => {
		setTimeout(() => {
			fetchVolunteers();
		}, 1500);
	}, [pageIndex, filtersData.SortBy, filtersData.Keyword]);

	const fetchJobTypes = async () => {
		try {
			// console.log(`Fetching JobTypes for page ${page}`);

			// Make the API request using the provided URL
			const response = await fetch(jobTypesApiUrl, {
				method: "GET", // GET method for fetching data
				headers: {
					"Accept-Language": document.documentElement.lang, // Use the defined language variable
				},
			});

			// Check if the response is OK (status code 2xx)
			if (!response.ok) {
				throw new Error(`Error: ${response.status}`);
			}

			// Parse the response data
			const data = await response.json();
			console.log("API Response:", data.data);

			// Check if the data contains the necessary attributes before setting state
			if (data.data && data.data.length > 0) {
				setJobTypes(data.data);
			} else {
				throw new Error("Unexpected API response structure");
			}
		} catch (error) {
			console.error("Error fetching JobTypes:", error);
			setError(error.message || "An unexpected error occurred"); // Set the error state
		} finally {
			setLoading(false); // Stop loading state
		}
	};

	const fetchVolunteers = async () => {
		setLoading(true); // Start loading state
		setError(null); // Clear any previous errors

		try {
			// Make the API request using the provided URL
			const volunteersResponse = await BSHelper.fetchExternalApiData(volunteersListApiUrl, {
				...filtersData,
				pageIndex,
				pageSize
			});

			// Check if the data contains the necessary attributes before setting state
			if (volunteersResponse.data && volunteersResponse.data.count > 0) {
				setVolunteers(volunteersResponse.data.data || []);
				setTotalPages(volunteersResponse.data.totalPages);
				setTotalItems(volunteersResponse.data.total);
				setTotalItemsInCurrentPage(volunteersResponse.data.count);
				setPageIndex(volunteersResponse.data.page);
			} else {
				throw new Error("Something went wrong!");
			}
		} catch (error) {
			console.error("Error fetching volunteers:", error);
			setError(error.message || "An unexpected error occurred"); // Set the error state
		} finally {
			setLoading(false); // Stop loading state
		}
	};
	const handlePageChange = (page) => {
		setPageIndex(page);
	};

	return (
		<div className="job-list-frontend">
			<Filters
				filtersData={filtersData}
				setFiltersData={setFiltersData}
				jobTypes={jobTypes}
				onApplyFilters={fetchVolunteers}
				phrases={bseitEditorVars.phrases}
			/>

			{loading && <LoadingIcon />}

			{/* {error && <ErrorMessage message={error} />} */}

			{!loading && (
				<div className="py-5">
					<VolunteersList volunteers={volunteers} phrases={bseitEditorVars.phrases}/>
				</div>
			)}

			{!loading && totalPages > 1 && (
				<Pagination
					currentPage={pageIndex}
					totalPages={totalPages}
					onPageChange={handlePageChange}
				/>
			)}
		</div>
	);
}

const root = createRoot(document.getElementById("volunteersListRoot"));
root.render(<View />);
